import React from "react";
import { useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { constructOrderDate } from "../../helper/DateFormatter";
import { BiTime } from "react-icons/bi";
import { TiLocationArrow } from "react-icons/ti";
import style from "./Details.module.scss";

import Charts from "./Charts";
import Pagination from "../../components/paginationCopy/Pagination";

const RiderDetails = (props) => {
  let orders = props.order ?? {};

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const size = 6;
  const pagesVisited = pageNumber * size;
  const pageCount = Math.ceil(Object.keys(orders)?.length / size);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  return (
    <div>
      <Row>
        <div className={style.header}>
          {/* <p>Location: {props.location}</p> */}
          <div className="d-flex gap-2 align-items-center">
            <p>
              <BiTime size={30} color="#950303" />
            </p>
            <p>Last Seen: {props.lastSeen}</p>
          </div>
          <div className="d-flex gap-2 align-items-center">
            <p>
              <TiLocationArrow size={30} color="#950303" />
            </p>
            <p>Track Type: {props.type}</p>
          </div>
        </div>
      </Row>
      <Row>
        <Col md={3}>
          <Charts
            label="Total Orders"
            value={props.total}
            bgColor="linear-gradient(263.32deg, #aba3a3 0.96%, #aba3a3 100%)"
          />
          <Charts
            label="Awaiting Orders"
            value={props.awaiting}
            bgColor="linear-gradient(263.32deg, #051EA4 0.96%, #1A8EF0 100%)"
          />
          <Charts
            label="Completed Orders"
            value={props.completed}
            bgColor="linear-gradient(263.28deg, #2A9D8F 1.44%, #2A9D8F 1.45%, #41C768 100%)"
          />
          <Charts
            label="Declined Orders"
            value={props.decline}
            bgColor="linear-gradient(263.39deg, #fd1d1d 0%, #e8b7b7 100%)"
          />
        </Col>

        <Col md={9}>
          <div className="d-flex justify-content-between">
            <div></div>
            {/* <Search placeholder="Find a dispatch" onChange={handleChange} /> */}
          </div>
          <section style={{ maxWidth: "100%", margin: "auto" }}>
            <Table bordered responsive className="mt-1">
              <thead>
                <tr className={style.TableHeadRow}>
                  <th>Order id</th>
                  <th>
                    <div className="d-flex align-items-center align-items-center">
                      Category
                    </div>
                  </th>
                  <th>
                    <div className="d-flex align-items-center align-items-center">
                      Product
                    </div>
                  </th>
                  <th>
                    <div className="d-flex align-items-center align-items-center">
                      Qty
                    </div>
                  </th>

                  <th>
                    <div className="d-flex align-items-center align-items-center">
                      Time Accepted
                    </div>
                  </th>
                  <th>
                    <div className="d-flex align-items-center align-items-center">
                      Status
                    </div>
                  </th>
                </tr>
              </thead>
              {Object.keys(orders)?.length > 0 ? (
                <tbody>
                  {Object.keys(orders)
                    ?.sort((a, b) => (orders[a].time > orders[b].time ? -1 : 1))

                    ?.slice(pagesVisited, pagesVisited + size)
                    ?.map((item, i) => (
                      <tr className={style.tableBodyRow} key={i}>
                        <td style={{ width: "10vw" }}>
                          {orders[item].orderNo}
                        </td>
                        <td style={{ width: "10vw" }}>
                          {orders[item].category}
                        </td>
                        <td style={{ width: "7vw" }}>{orders[item].product}</td>

                        <td>
                          {orders[item].product === "Oxygen"
                            ? orders[item].qty
                            : orders[item].pint}
                        </td>

                        <td style={{ width: "15vw" }}>
                          {constructOrderDate(orders[item].time)}
                        </td>
                        <td style={{ width: "10vw" }}>{orders[item].status}</td>
                      </tr>
                    ))}
                </tbody>
              ) : (
                <div className="d-flex justify-content-center align-items-center">
                  No record found
                </div>
              )}
            </Table>{" "}
            {Object.keys(orders)?.length > size && (
              <Pagination pageCount={pageCount} onPageChange={changePage} />
            )}
          </section>
        </Col>
      </Row>
    </div>
  );
};

export default RiderDetails;
